module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921012649_T.9ea3ca75.jpg";